import { request } from '@/utils/axiosFun.js'

//算法维护 列表分页查询
export const getAlgorithmList = (params) => {
    // let spaceUrl= `?companyName=${query.companyName}&substationIds=${query.substationIds}&switchFactor=${query.switchFactor}&switchModel=${query.switchModel}&pagenum=${query.pagenum}&pagesize=${query.pagesize}&orderByColumn=${query.orderByColumn}&sort=${query.sort}`
    return request('post', `/yunDuanUrl/dmsm-service-cloud/algorithm/getAlgorithmList?pagenum=${params.pagenum}&pagesize=${params.pagesize}`,params)
}
//获取变电站名称
export const bdzNumber = (query)=>{
    return request('post', '/yunDuanUrl/dmsm-service-cloud/user/getSubstationOptionByCompany',query)
}

//文件上传
export const upload = (query,file)=>{
    let data = `?fileName=${query.fileName}&fileType=${query.fileType}&substation=${query.substation}&substationName=${query.substationName}&termID=${query.termID}&clientID=${query.clientID}`
    return request('post', '/yunDuanUrl/dmsm-service-cloud/algorithm/uploadFile' + data,file,{},'F','multipart/form-data')
}
